'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@repo/ui/lib/utils';
import { BundleProductCard } from './bundle-product-card';
import type { BundleProduct } from './bundle-types';
const COLUMN_CLASSES: Record<'3' | '4', string> = {
  '3': 'grid-cols-2 lg:grid-cols-3',
  '4': 'grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
};
interface BundleGridProps {
  products: BundleProduct[];
  columns: '3' | '4';
  onClearFilters: () => void;
}
export function BundleGrid(t0) {
  const $ = _c(10);
  const {
    products,
    columns,
    onClearFilters
  } = t0;
  if (products.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-lg text-neutral-500">No styles match your search.</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== onClearFilters) {
      t2 = <div className="py-16 text-center">{t1}<button type="button" onClick={onClearFilters} className="mt-4 text-sm font-medium text-brand-accent hover:underline">Clear filters</button></div>;
      $[1] = onClearFilters;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const t1 = COLUMN_CLASSES[columns];
  let t2;
  if ($[3] !== t1) {
    t2 = cn("grid gap-4 sm:gap-6", t1);
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== products) {
    t3 = products.map(_temp);
    $[5] = products;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(product) {
  return <BundleProductCard key={product.id} product={product} />;
}